<script setup lang="ts">
import Popper from 'vue3-popper';
import ImageMedia from '../media/ImageMedia.vue';

const props = defineProps({
  theme: {
    type: String,
    default: 'base',
  },
  arrow: {
    type: Boolean,
    default: true,
  },
  image: {
    type: String,
    default: '',
  },
  offsetDistance: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <Popper
    :class="theme"
    class="tooltip"
    :arrow="arrow"
    hover
    openDelay="200"
    closeDelay="200"
    :offsetDistance="offsetDistance"
  >
    <slot></slot>

    <template #content="props">
      <slot name="content" v-bind="props">
        {{ content }}
      </slot>
      <slot name="image" v-bind="props" v-if="image">
        <ImageMedia :filename="image" />
      </slot>
    </template>
  </Popper>
</template>

<style lang="scss" scoped>
@use 'core/colors';
@use 'core/layout/grid-vars';
@use 'core/typography/fonts';
@use 'core/util';

//commenting out as it seems this code is messing up tooltip placement all over the app
// :deep(.popper) {
//   min-width: 120px;
//   text-align: left;
//   transform: translate3d(-39px, 25px, 0px) !important;
// }

// themes

.narrow {
  --popper-theme-background-color: rgba(69, 57, 96, 0.85);
  --popper-theme-background-color-hover: rgba(69, 57, 96, 0.95);
  --popper-theme-text-color: #e0dde4;
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-color: rgba(132, 115, 152, 0.2);
  --popper-theme-border-radius: 8px;
  --popper-theme-padding: 4px 9px 6px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);

  :deep(.popper) {
    @include fonts.font-size(12);

    backdrop-filter: blur(7.5px);
  }
}

.narrow-fixed {
  @extend .narrow;

  :deep(.popper) {
    position: fixed !important; // hack to fix hidden popups in sidebar
  }
}

.sidebar-menu-options {
  :deep(.popper) {
    padding: 0.8rem;

    .sidebar-menu {
      .sidebar-menu__item {
        margin-bottom: 0;

        &:not(:first-child) {
          margin-top: grid-vars.space(2);
        }
      }
    }
  }
}

.base {
  --popper-theme-background-color: #847398;
  --popper-theme-background-color-hover: #847398;
  --popper-theme-text-color: #e0dde4;
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-color: #847398;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 0.5rem 1rem;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);

  :deep(.popper) {
    @include fonts.font-size(12);
    @include util.border-radius($multiplier: 4);

    max-width: 16rem;

    &:hover {
      #arrow {
        &:before {
          background: colors.color(grey);
        }
      }
    }

    #arrow {
      &:before {
        background: colors.color(grey);
      }
    }
  }
}
</style>
